module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "400px",
      "width": "100%",
      "background": "#ccc",
      "position": "relative"
    },
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "searchbox"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "search Apollo locations",
      "id": "search"
    },
    on: {
      "change": _vm.search,
      "keyup": _vm.search
    }
  }), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "locationlist"
    }
  }, _vm._l((_vm.locationlist), function(location) {
    return _c('li', {
      attrs: {
        "lat": location.lat,
        "lng": location.lng
      },
      domProps: {
        "textContent": _vm._s(location.name.toLowerCase())
      },
      on: {
        "click": _vm.center
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcce40c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations.vue
// module id = 169
// module chunks = 0